import React from 'react'

export default function Card({ children }) {
    return (
        <div style={{ overflow: 'auto' }} className="card">
            <div className="card-content">{children}</div>
        </div>
    )
}
